// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IBiUF","right":"styles_right__ksS4R"};